<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <HeaderMenu/>
        </div>

        <div class="section section-color center">
            <div class="w-container">
                <div class="key-number">Plans &amp; Pricing</div>
            </div>
        </div>

        <Plans/>

        <Footer/>
    </div>
</template>

<style>
</style>

<script>
    import HeaderMenu from "../components/HeaderMenu";
    import Plans from "../components/Plans";
    import Footer from "../components/Footer";

    export default {
        components: {
             HeaderMenu, Plans, Footer
        }
    }
</script>
